import { render, staticRenderFns } from "./MatchFinished.vue?vue&type=template&id=106ff76c&scoped=true"
import script from "./MatchFinished.vue?vue&type=script&lang=js"
export * from "./MatchFinished.vue?vue&type=script&lang=js"
import style0 from "./MatchFinished.vue?vue&type=style&index=0&id=106ff76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ff76c",
  null
  
)

export default component.exports